const state = () => ({
  checklistsOverview: null,
  checklists: [], // [{ label: "checklist label", id: "some identifier for a checklist"}]
});

const getters = {};

const mutations = {
  setData(state, data) {
    state[data.label] = data.data;
  },
  reset(state) {
    state.checklistsOverview = null;
    state.checklists = [];
  },
};

const actions = {
  async getViewData({ commit, state }, { url }) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}${url}`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {});
  },

  async requirementChecklist(
    { dispatch, commit, state },
    { queryString, data }
  ) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/workspace/requirements-tree-terms`,
      data,
    };
    if (queryString) {
      body.url = `${body.url}?${queryString}`;
    }
    const newChecklist = data.newChecklist;
    return await this.$axios(body)
      .then((data) => {
        if(newChecklist) {
          dispatch("refetchChecklists").then((checklists) => {
            commit("setData", {
              data: checklists.data,
              label: "checklists"
            });
          }).catch(error => {
            console.error("Error refetching checklists");
            return error;
          });
        }
        return data;
      })
      .catch(({ response }) => {});
  },

  async countryReportChecklist({ dispatch, commit, state }, data) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/workspace/guide-sections`,
      data,
    };
    const newChecklist = data.newChecklist;
    return await this.$axios(body)
      .then((data) => {
        if(newChecklist) {
          dispatch("refetchChecklists").then((checklists) => {
            commit("setData", {
              data: checklists.data,
              label: "checklists"
            });
          }).catch(error => {
            console.error("Error refetching checklists");
            return error;
          });
        }
        return data;
      })
      .catch(({ response }) => {});
  },

  async regulatoryUpdateChecklist({ dispatch, commit, state }, data) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/workspace/regulatory-update`,
      data,
    };
    const newChecklist = data.newChecklist;
    return await this.$axios(body)
      .then((data) => {
        if(newChecklist) {
          dispatch("refetchChecklists").then((checklists) => {
            commit("setData", {
              data: checklists.data,
              label: "checklists"
            });
          }).catch(error => {
            console.error("Error refetching checklists");
            return error;
          });
        }
        return data;
      })
      .catch(({ response }) => {});
  },

  async reportbuilderGuideChecklist({ dispatch, commit, state }, data) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/workspace/report-builder/guide-sections?${data.queryParams.join("&")}`,
      data: data.payload,
    };
    const newChecklist = data.payload.newChecklist;
    return await this.$axios(body)
      .then((data) => {
        if(newChecklist) {
          dispatch("refetchChecklists").then((checklists) => {
            commit("setData", {
              data: checklists.data,
              label: "checklists"
            });
          }).catch(error => {
            console.error("Error refetching checklists");
            return error;
          });
        }
        return data;
      })
      .catch(({ response }) => {});
  },

  async reportbuilderLicenseChecklist({ dispatch, commit, state }, data) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/workspace/report-builder/requirement-license?${data.queryParams.join("&")}`,
      data: data.payload,
    };
    const newChecklist = data.payload.newChecklist;
    return await this.$axios(body)
      .then((data) => {
        if(newChecklist) {
          dispatch("refetchChecklists").then((checklists) => {
            commit("setData", {
              data: checklists.data,
              label: "checklists"
            });
          }).catch(error => {
            console.error("Error refetching checklists");
            return error;
          });
        }
        return data;
      })
      .catch(({ response }) => {});
  },

  async articleChecklist({ dispatch, commit, state }, data) {
    const body = {
      method: "POST",
      url: `${this.$config.apiURL}/workspace/article`,
      data,
    };
    const newChecklist = data.newChecklist;
    return await this.$axios(body)
      .then((data) => {
        if(newChecklist) {
          dispatch("refetchChecklists").then((checklists) => {
            commit("setData", {
              data: checklists.data,
              label: "checklists"
            });
          }).catch(error => {
            console.error("Error refetching checklists");
            return error;
          });
        }
        return data;
      })
      .catch(({ response }) => {});
  },

  async refetchChecklists({ commit, state }, data) {
    const body = {
      method: "GET",
      url: `${this.$config.apiURL}/workspace/checklists`,
    };
    return await this.$axios(body)
      .then((data) => data)
      .catch(({ response }) => {});
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
